import type { FaireProductEntity } from "../../entity_types/product";

export const p_bb85pam5s2: FaireProductEntity = {
  token: "p_bb85pam5s2",
  type: "product",
  name: "Ultimate Smudging Deluxe Kit.",
  brandToken: "b_8h5sk43qpz",
  brandName: "Down To Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/15e0d5962e34bf1f52efa67daf0dce2560569b44c273e5721e48baf99a8d6e4a.jpeg",
  galleryImageUrls: [],
  priceDollars: 19,
  description:
    "Smudging sampler kit includes \n\n * Desert Sage \n * Cedar \n * White Sage \n * Yerba Santa \n * Sweetgrass \n * Palo Santo ",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:49.921Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
